// extracted by mini-css-extract-plugin
module.exports = {"form":"MERecord_form__35ygC","content":"MERecord_content__3sKx6","contentMain":"MERecord_contentMain__1MVeJ","select":"MERecord_select__33vu7"};